export default "__VITE_ASSET__B_xZ87ID__"